import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { QueryKeys } from "../queryKeys";

export type GetAcquirerBankListRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
};
async function getAcquirerBankList(status?: string): Promise<any> {
  try {
    const response = await axiosInstance.get("/AcqBin/AcquirerBanks", {
      params: { status: status }
    });
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetAcquirerBankList(status?: string) {
  return useQuery<any | undefined, Error>(
    [QueryKeys.GetAcquirerBankList, status],
    () => getAcquirerBankList(status),
    { cacheTime: Infinity }
  );
}
